import { render, staticRenderFns } from "./28shajingwan.vue?vue&type=template&id=5d655910&"
import script from "./28shajingwan.vue?vue&type=script&lang=js&"
export * from "./28shajingwan.vue?vue&type=script&lang=js&"
import style0 from "./28shajingwan.vue?vue&type=style&index=0&id=5d655910&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports